import React, { useState, useEffect } from "react";
import { PageHeader } from "../../../Common";
import services from "../services";
import authService from "../../Common/services";
import MessageModal from "../../../UI/Modal/MessageModal";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import groupService from "../../Group/services";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { NetOutturnAddEditSchemaObject } from "../NetOutturmSchema";
import { validate } from "../../Common";
import tokenService from "../../../Common/tokenDecoder";

const screenCode = "NETOUTTURN";

export function NetOutturnAddEdit(props) {
  const currentDate = new Date();
  const defaultSearchMonth = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1
  ).padStart(2, "0")}`;

  const [netOutturnData, setNetOutturnData] = useState({
    netOutturnID: 0,
    OutturnID: 0,
    groupID: "0",
    estateID: "0",
    searchMonth: defaultSearchMonth,
    Outturn: "", 
    updatedBy: null,
    isActive: true, 
  });
  const [groups, setGroups] = useState({});
  const [estates, setEstates] = useState({});
  const [errors, setErrors] = useState({});
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    description: "Save success",
  });
  const [isUpdate, setIsUpdate] = useState(false);
  const [permissionList, setPermissions] = useState({
            isAddEditEnabled: false,
            isGroupFilterEnabled: false,
            isOperationEntityFilterEnabled: false
        });
    const [isEnable, setIsEnable] = useState(true);
    const [multipleEstates, setMultipleEstates] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
        await trackPromise(getPermissions());
        await getAllGroups();
        if (props.location?.data) {
            setNetOutturnData((prev) => ({
                ...prev,
                netOutturnID: props.location.data.netOutturnID || 0,
                groupID: props.location.data.groupID || "0",
                estateID: props.location.data.estateID || "0",
                searchMonth: props.location.data.searchMonth || defaultSearchMonth,
                Outturn: props.location.data.Outturn || "",
                isActive: props.location.data.isActive || true,
            }));
            setIsUpdate(true);
        } else {
            const token = tokenService.getUserDetailsFromTokenV2();
            setNetOutturnData((prev) => ({
                ...prev,
                groupID: token.groupID || "0",
                estateID: token.operationEntityID || "0",
            }));
        }
      };
      fetchData();
  }, [props.location?.data]);
  
  useEffect(() => {
    getAllGroups();
    getPermissions(); 
    getAllGroups(); 
    getEstatesByGroupID(); 
  }, []); 

  async function getPermissions() {
    try {
      const permissions = await authService.getPermissionsByScreen(screenCode);
      const isAuthorized = permissions.find((p) => p.permissionCode === "ADDEDITNETOUTTURN");
      if (!isAuthorized) props.history.push("/unauthorized");

      const isAddEditEnabled = permissions.find(p => p.permissionCode === 'VIEWNETOUTTURN');
      const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
      const isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');
      setPermissions({
            ...permissionList,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isAddEditEnabled: isAddEditEnabled !== undefined,
        });

      const token = tokenService.getUserDetailsFromTokenV2();
      if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setNetOutturnData({
                ...netOutturnData,
                groupID: token.groupID
            });

        } else {
            setNetOutturnData({
                ...netOutturnData,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        }
      setNetOutturnData((prev) => ({
        ...prev,
        groupID: token.groupID || "0",
        estateID: token.operationEntityID || "0",
      }));
      setIsUpdate(!!props.location?.data);
    } catch (error) {
      setMessageModel({
        hidden: false,
        type: "Error",
        description: "Failed to load permissions",
      });
    }
  }

  async function getAllGroups() {
    try {
      const data = await groupService.getGroupsForDropdown();
      setGroups(data || {});
    } catch (error) {
      setMessageModel({
        hidden: false,
        type: "Error",
        description: "Failed to load groups",
      });
    }
  }

  async function getEstatesByGroupID() {
    try {
      const token = tokenService.getUserDetailsFromTokenV2();
      const data = await services.getEstatesByGroupID(token.groupID);
      setEstates(data || {});
    } catch (error) {
      setMessageModel({
        hidden: false,
        type: "Error",
        description: "Failed to load estates",
      });
    }
  }
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "Outturn") {
        if (value === "") {
            setNetOutturnData((prev) => ({
                ...prev,
                [name]: value,
            }));
        } else {
            const regex = /^\d{1,2}(\.\d{0,2})?$/;
            if (regex.test(value)) {
                setNetOutturnData((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
        }
    } else {
        setNetOutturnData((prev) => ({
            ...prev,
            [name]: value,
        }));
    }
    const schema = Joi.object(NetOutturnAddEditSchemaObject).options({ allowUnknown: true });
    const updatedData = { ...netOutturnData, [name]: value };
    const errors = validate(schema, updatedData);
    setErrors(errors || {});

    if (name === "groupID") getEstatesByGroupID();
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const schema = Joi.object(NetOutturnAddEditSchemaObject).options({ allowUnknown: true });
    const errors = validate(schema, netOutturnData);
    setErrors(errors || {});
    if (errors && Object.keys(errors).length > 0) return;
    const [year, month] = netOutturnData.searchMonth.split("-");
    const data = {
      netOutturnID: 0,
      groupID: parseInt(netOutturnData.groupID),
      estateID: parseInt(netOutturnData.estateID),
      year: parseInt(year),
      month: parseInt(month),
      Outturn: parseFloat(netOutturnData.Outturn) || 0,
      createdBy: parseInt(tokenService.getUserIDFromToken()),
      isActive: netOutturnData.isActive, 
    };
    
    try {
        const response = await services.SaveNetOutturnData(data);
        setMessageModel({
            hidden: false,
            type: response.statusCode === "Success" ? "Success" : "Error",
            description: response.message || "Data saved",
        });

        setTimeout(() => {
            setMessageModel((prev) => ({ ...prev, hidden: true }));
            if (response.statusCode === "Success") props.history.push("/NetOutturn");
        }, 4000);
    } catch (error) {
        setMessageModel({
            hidden: false,
            type: "Error",
            description: "Failed to save data",
        });
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const schema = Joi.object(NetOutturnAddEditSchemaObject).options({ allowUnknown: true });
    const errors = validate(schema, netOutturnData);
    setErrors(errors || {});

    if (errors && Object.keys(errors).length > 0) return;

    const [year, month] = netOutturnData.searchMonth.split("-");
    const data = {
        netOutturnID: netOutturnData.netOutturnID, 
        groupID: parseInt(netOutturnData.groupID),
        estateID: parseInt(netOutturnData.estateID),
        year: parseInt(year),
        month: parseInt(month),
        Outturn: parseFloat(netOutturnData.Outturn) || 0,
        updatedBy: parseInt(tokenService.getUserIDFromToken()),
        isActive: netOutturnData.isActive,
    };
    try {
        const response = await services.UpdateNetOutturnData(data);
        setMessageModel({
            hidden: false,
            type: response.statusCode === "Success" ? "Success" : "Error",
            description: response.message || "Data updated",
        });

        setTimeout(() => {
            setMessageModel((prev) => ({ ...prev, hidden: true }));
            if (response.statusCode === "Success") props.history.push("/NetOutturn");
        }, 4000);
    } catch (error) {
        setMessageModel({
            hidden: false,
            type: "Error",
            description: "Failed to update data",
        });
    }
  };

  const handleCancel = () => {
    props.history.push("/NetOutturn");
  };

  const modalDismissHandler = () => {
    setMessageModel((prev) => ({ ...prev, hidden: true }));
  };

  function generateDropDownMenu(data) {
            let items = [];
            if (data != null) {
                for (const [key, value] of Object.entries(data)) {
                    items.push(
                        <MenuItem key={key} value={key}>
                            {value}
                        </MenuItem>
                    );
                }
            }
            return items;
        }

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card">
          <PageHeader
            title={isUpdate ? "Edit Net Outturn" : "Add Net Outturn"}
            isButtonEnable={true}
            buttonText="Back to Listing"
            path="/NetOutturn"
          />
          <div className="card-body">
            <form onSubmit={isUpdate ? handleUpdate : handleSave}>
              <div className="form-group row">
                <div className="col-md-3 pb-1">
                  <InputLabel shrink id="groupID">
                    Group *
                  </InputLabel>
                  <Select
                    fullWidth
                    labelId="groupID"
                    id="groupID"
                    name="groupID"
                    value={netOutturnData.groupID}
                    onChange={handleChange}
                    disabled={!isEnable || !permissionList.isGroupFilterEnabled}
                  >
                    <MenuItem value="0">--Select Group--</MenuItem>
                    {Object.entries(groups).map(([key, value]) => (
                      <MenuItem key={key} value={key}>
                        {value}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.groupID && <FormHelperText error>{errors.groupID}</FormHelperText>}
                </div>
                <div className="col-md-3 pb-1">
                  <InputLabel shrink id="estateID">
                    Estate *
                  </InputLabel>
                  <Select
                    fullWidth
                    labelId="estateID"
                    id="estateID"
                    name="estateID"
                    value={netOutturnData.estateID}
                    onChange={handleChange}
                    disabled={isUpdate || !isEnable || !permissionList.isOperationEntityFilterEnabled}
                  >
                    <MenuItem value="0">--Select Estate--</MenuItem>
                    {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                  </Select>
                  {errors.estateID && <FormHelperText error>{errors.estateID}</FormHelperText>}
                </div>
                <div className="col-md-3 pb-1">
                  <InputLabel shrink id="searchMonth">
                    Month *
                  </InputLabel>
                  <TextField
                    fullWidth
                    id="searchMonth"
                    name="searchMonth"
                    type="month"
                    value={netOutturnData.searchMonth}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isUpdate}
                  />
                  {errors.searchMonth && (
                    <FormHelperText error>{errors.searchMonth}</FormHelperText>
                  )}
                </div>
                <div className="col-md-3 pb-1">
                  <InputLabel shrink id="Outturn">
                    Net Outturn
                  </InputLabel>
                  <TextField
                    fullWidth
                    id="Outturn"
                    name="Outturn" 
                    type="number"
                    value={netOutturnData.Outturn} 
                    onChange={handleChange}
                    inputProps={{
                      step: "0.01", 
                      min: "0",
                    }}
                    variant="outlined"
                  />
                  {errors.Outturn && <FormHelperText error>{errors.Outturn}</FormHelperText>} 
                </div>
              </div>
              <div className="card-footer">
                <button type="submit" className="btn btn-primary">
                  {isUpdate ? "UPDATE" : "SAVE"}
                </button>
                <button
                  type="button"
                  className="btn btn-warning pull-right"
                  onClick={handleCancel}
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.description}
        clicked={modalDismissHandler}
      />
      <LoadingSpinerComponent />
    </div>
  );
}